import React from 'react';
import { IMAGES } from '../data/site';
export function Hero() {
  return <section aria-labelledby="hero-heading" className="relative isolate w-full overflow-hidden bg-kosin-charcoal" data-id="element-141" data-mp="ejwl1drxcj8d">
      <img src={IMAGES.hero} alt="Bright living room with large replacement home windows" width={1199} height={800} className="absolute inset-0 h-full w-full object-cover object-[68%_center] sm:object-[60%_center] lg:object-[center_38%]" data-id="element-142" data-mp="9k0bkz0gjzlf" />
      <div className="absolute inset-0 bg-kosin-charcoal/45" aria-hidden="true" data-id="element-143" data-mp="x9usbrnwe8ay" />

      <div className="relative mx-auto flex max-w-shell flex-col justify-center px-[18px] py-8 sm:px-6 sm:py-14 lg:min-h-[450px] lg:py-16" data-id="element-144" data-mp="sb1axo5hpx5i">
        <div className="max-w-[720px]" data-id="element-145" data-mp="nbewxchu8cvn">
          <p className="text-[15px] font-semibold text-white sm:text-[16px]" data-id="element-146" data-mp="nekm0rqgverd">
            Kosin’s Glass
          </p>
          <h1 id="hero-heading" className="mt-3 text-[34px] font-bold leading-[1.1] text-white sm:text-[38px] lg:text-[54px]" data-id="element-147" data-mp="382p6pg8rpjmq">
            Glass repair, replacement &amp; custom glass
          </h1>
          <p className="mt-4 max-w-[560px] text-[17px] leading-relaxed text-white sm:text-[18px]" data-id="element-148" data-mp="3o6kdjcmbi22h">
            For your vehicle, home and business in Southeast Michigan.
          </p>
          <p className="mt-2 text-[14px] text-white/80" data-id="element-149" data-mp="3e8mur4n88xh9">
            Family-owned in Howell since 2000.
          </p>

          <div className="mt-6 flex flex-col gap-3 min-[380px]:flex-row sm:items-center" data-id="element-150" data-mp="30h9bzsx583na">
            <a href="#quote" className="focus-light flex-1 rounded bg-kosin-red px-4 py-3.5 text-center text-[16px] font-semibold text-white hover:bg-kosin-bright transition-colors duration-150 ease-kosin sm:flex-none sm:px-6" data-id="element-151" data-mp="359szbhlmud5a">
              Get a free quote
            </a>
            <a href="#services" className="focus-light flex-1 rounded border border-white/70 px-4 py-3.5 text-center text-[16px] font-semibold text-white hover:bg-white hover:text-kosin-charcoal transition-colors duration-150 ease-kosin sm:flex-none sm:px-6" data-id="element-152" data-mp="2hjoytj3qqtii">
              Explore services
            </a>
          </div>
        </div>
      </div>
    </section>;
}